@if (
  {
    title: title(),
    subTitle: subTitle()
  };
  as STATE
) {
  <section class="card">
    <div class="card__icon">
      <img
        ngSrc="/assets/icons/empty.svg"
        [width]="iconSize()"
        [height]="iconSize()"
        priority
        [alt]="STATE.title || 'Empty data'"
      />
    </div>
    <div>
      <h3 class="card__title">{{ STATE.title }}</h3>
      <span class="card__subtitle">{{ STATE.subTitle }}</span>
    </div>
  </section>
}
